<template>
    <div>
        <figure class="image is-5by3">
            <img v-if="localImage" :src="localImage" class="" />
            <img v-else src="/img/project-default.png" class="" />
        </figure>
        <div class="columns is-mobile px-3">
            <div class="column px-0">
                <div class="file is-fullwidth is-primary">
                    <label v-if="!uploading" class="">
                        <input
                            class="file-input"
                            type="file"
                            accept="image/*"
                            multiple="false"
                            @input="handleImage"
                        />
                        <span class="file-cta is-radiusless">
                            <span
                                v-t="'projectConfiguration.select_image'"
                                class="file-label"
                            />
                        </span>
                    </label>
                    <a v-else class="button is-loading" />
                </div>
            </div>
            <div class="column is-6 px-0" v-if="localImage">
                <a
                    v-t="'projectConfiguration.delete_image'"
                    class="button is-danger is-fullwidth is-radiusless"
                    @click="deleteImage"
                />
            </div>
        </div>
        <!--<div v-if="canEdit" id="button-container">
            <div class="field is-grouped">
                <div
                    class="file control"
                >
                    <label v-if="!uploading" class="">
                        <input
                            class="file-input"
                            type="file"
                            accept="image/*"
                            multiple="false"
                            @input="handleImage"
                        />
                        <span class="file-cta">
                            <span
                                v-t="'projectConfiguration.select_image'"
                                class="file-label"
                            />
                        </span>
                    </label>
                    <a v-else class="button is-loading" />
                </div>

                <p v-if="localImage" class="control">
                    <a
                        v-t="'projectConfiguration.delete_image'"
                        class="button is-danger"
                        @click="deleteImage"
                    />
                </p>
            </div>
        </div>-->
    </div>
</template>

<script>
import { upload } from '@/services/API';
export default {
    props: {
        image: {
            type: Object,
            default: () => {
                return {};
            },
        },
        canEdit: { type: Boolean, default: false },
    },
    data() {
        return {
            localImage: this.image ? this.image.url : null,
            uploading: false,
        };
    },
    methods: {
        async handleImage(ev) {
            if (!ev.target.files) {
                console.log('no files!');
                return;
            }
            var fr = new FileReader();
            fr.onload = () => {
                this.localImage = fr.result;
            };
            fr.readAsDataURL(ev.target.files[0]);
            this.uploading = true;
            let response = await upload(`image`, ev.target.files).catch(
                (err) => {
                    alert(this.$t(`Error.${err}`));
                    this.deleteImage();
                    return this.$emit('error');
                }
            );
            this.uploading = false;
            if (response.data) {
                this.localImage = response.data.image[0].url;
                this.$emit('update:image', response.data.image[0]);
            }
        },
        deleteImage() {
            this.localImage = null;
            this.$emit('update:image', undefined);
        },
    },
};
</script>

<style scoped>
/*.image.is-5by3 {
    border: 2px solid #f4f4f4;
    border-radius: 4px;
    border-bottom: none;
}*/
img {
    object-fit: cover;
}
.delete {
    margin-bottom: 5px !important;
}

.file.is-fullwidth {
    display: block;
}
.file-cta {
    display: block;
    text-align: center;
}
.file-label {
    display: block;
    line-height: 1.9rem;
}
</style>
